<template>
  <div></div>
</template>

<script>
export default {
  name: "FAQ"
}
</script>

<style scoped>

</style>
